import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

export interface ChoiceOption {
  id: string
  label: string
  value: string
  isActive: boolean
}

export interface ICustomField {
  [key: string]: any
}

class CustomField extends Model<ICustomField> {
  static urlRoot() {
    return '/custom_fields'
  }

  static UsageGroups = {
    documents: 'documents',
    employeeProfile: 'employee-profile',
    expenses: 'expenses',
    performanceRoleQuestions: 'performance-role-questions',
    performanceRoleQuestionsSubject: 'performance-role-questions-subject',
    performanceRoleQuestionsReviewer: 'performance-role-questions-reviewer',
    timetracking: 'timetracking',
    packageOfficeInfo: 'packages-office-info',
    packagesLegalEntityInfo: 'packages-legal-entity-info',
    payrollSettings: 'payroll-settings',
    payrollSupplements: 'payroll-supplements',
    employeeQuestions: 'employees-questions',
    generalInformation: 'general-information',
    basicInformation: 'basic-information',
    identificationNumber: 'identification-number',
    legalInformation: 'legal-information',
    timeTrackingProjects: 'time-tracking-projects',
    surveys: 'surveys',
    contractVersions: 'contract-versions',
  }

  constructor(attr: ICustomField = {}) {
    super(attr)
    makeObservable(this, {
      isInstalled: computed,
      isReadonly: computed,
      choiceOptions: computed,
    })
  }

  get isInstalled(): boolean {
    return this.attributes.installed
  }

  get isReadonly(): boolean {
    return this.attributes.is_readonly
  }

  get choiceOptions(): ChoiceOption[] {
    return (
      this.attributes.choice_options?.map((opt: any) => ({
        id: opt.id,
        label: opt.label,
        value: opt.value,
        isActive: opt.is_active,
      })) || []
    )
  }
}

export default CustomField
